import { render, staticRenderFns } from "./UpgradeToPremiumPopUp.vue?vue&type=template&id=41ad20da&"
import script from "./UpgradeToPremiumPopUp.vue?vue&type=script&lang=js&"
export * from "./UpgradeToPremiumPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports